/* =========================================================================
   FEBELVN core utilities  —  GOKWIK CART MODE

   The theme no longer ships a cart drawer. The GoKwik Cart app embed owns
   the cart. This file gives the rest of the theme:

     FV.lockScroll() / FV.unlockScroll()  — one owner for the body scroll lock
     FV.addToCart(variantId, qty, button) — the ONLY way theme code adds items
     FV.openCart()                        — opens the GoKwik cart, safely
     FV.loadSwiper() / FV.loadScript()    — load libraries once, on demand

   Nothing in the theme may intercept a cart click or a cart form any more.
   That is the GoKwik cart's job.
   ========================================================================= */
(function () {
  if (window.FV) return;

  var FV = {};

  /* ======================================================================
     1. Body scroll lock
     Four components used to lock scroll with two incompatible mechanisms
     (body.classList vs body.style.overflow), so they unlocked each other
     and left mobile frozen. Everything goes through this counter now.
     The GoKwik cart manages its own lock — do not call these for the cart.
     ====================================================================== */
  var locks = 0;

  function applyLock() {
    if (locks > 0) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
      document.body.style.overflow = '';
      document.body.style.position = '';
    }
  }

  FV.lockScroll = function () { locks++; applyLock(); };
  FV.unlockScroll = function () { locks = locks > 0 ? locks - 1 : 0; applyLock(); };
  FV.resetScroll = function () { locks = 0; applyLock(); };

  /* Safety nets so the page can never be left frozen */
  window.addEventListener('pageshow', FV.resetScroll);
  window.addEventListener('popstate', FV.resetScroll);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || e.code === 'Escape') FV.resetScroll();
  });

  /* ======================================================================
     2. Cart bridge to the GoKwik Cart (KwikCart)

     Theme code does exactly two things: add via /cart/add.js, then call
     FV.openCart(), which refreshes and opens the GoKwik drawer.
     ====================================================================== */

  /* True while the GoKwik drawer is on screen */
  function cartPanelIsOpen() {
    var host = document.querySelector('shadow-dom-container');
    var root = host && host.shadowRoot;
    var panel = root && root.querySelector('.sidecart');
    if (!panel) return false;
    var r = panel.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  FV.cartIsOpen = cartPanelIsOpen;

  /* ---- GoKwik Cart (KwikCart) ------------------------------------------
     The KwikCart app embed renders its drawer inside <shadow-dom-container>
     and exposes window.openGokwikSideCart / refreshSideCart /
     closeGokwikSideCart. We call those directly instead of clicking the cart
     icon (a click can toggle it shut).

     WATCHDOG: openGokwikSideCart() locks body + html scroll BEFORE the drawer
     paints. If the drawer failed to mount, the page used to stay frozen.
     Now, if no drawer appears, we unlock and fall back to the /cart page. */
  function kwikCartAvailable() {
    return typeof window.openGokwikSideCart === 'function';
  }
  function kwikCartRendered() {
    var host = document.querySelector('shadow-dom-container');
    var root = host && host.shadowRoot;
    return !!(root && root.querySelector('.sidecart'));
  }
  function cartUrl() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
  }
  function unfreeze() {
    try { if (typeof window.closeGokwikSideCart === 'function') window.closeGokwikSideCart(); } catch (e) {}
    document.body.style.removeProperty('overflow-y');
    document.documentElement.style.removeProperty('overflow-y');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    FV.resetScroll();
  }
  function watchdog() {
    setTimeout(function () {
      if (kwikCartRendered()) return;
      var locked = document.body.style.overflowY === 'hidden' ||
                   document.documentElement.style.overflowY === 'hidden';
      if (!locked) return; /* shopper already closed it, or it never locked */
      if (window.console) console.warn('[FV] GoKwik cart did not render — unlocking page and opening /cart');
      unfreeze();
      window.location.href = cartUrl();
    }, 1500);
  }
  FV.unfreeze = unfreeze;

  var opening = false;
  FV.openCart = function () {
    if (kwikCartAvailable()) {
      if (opening) return;
      opening = true;
      var refresh = typeof window.refreshSideCart === 'function'
        ? Promise.resolve().then(function () { return window.refreshSideCart(); }).catch(function () {})
        : Promise.resolve();
      refresh.then(function () {
        try { window.openGokwikSideCart(); } catch (e) {}
        watchdog();
      }).then(function () {
        setTimeout(function () { opening = false; }, 800);
      });
      return;
    }

    /* No GoKwik cart on the page (app embed disabled) — legacy behaviour */
    setTimeout(function () {
      if (cartPanelIsOpen()) return;
      window.location.href = cartUrl();
    }, 450);
  };

  /* Header cart icon: KwikCart binds its own click handler to it. If the
     drawer fails to render, unlock the page and go to /cart instead of
     leaving the shopper stuck. */
  document.addEventListener('click', function (e) {
    var icon = e.target && e.target.closest && e.target.closest('#cart-icon-bubble, .header__icon--cart');
    if (!icon || !kwikCartAvailable()) return;
    watchdog();
  }, true);

  /* Keep the header count in sync without a full page render */
  FV.refreshCartCount = function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.getElementById('cart-icon-bubble');
        if (!link) return cart;
        var bubble = link.querySelector('.cart-count-bubble');
        if (!bubble && cart.item_count > 0) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          link.appendChild(bubble);
        }
        if (bubble) {
          var n = bubble.querySelector('span[aria-hidden]');
          var sr = bubble.querySelector('.visually-hidden');
          if (n) n.textContent = cart.item_count;
          if (sr) sr.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
          bubble.style.display = cart.item_count > 0 ? '' : 'none';
          bubble.classList.remove('hidden');
        }
        return cart;
      })
      .catch(function () {});
  };

  /* The single add-to-cart path for ALL theme code */
  FV.addToCart = function (variantId, quantity, button) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var originalText = button ? button.innerHTML : null;

    if (button) {
      button.disabled = true;
      button.style.opacity = '0.65';
    }

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Add to cart failed');
        /* Tell any listener (GoKwik cart, analytics) that the cart changed */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fv-core', cartData: data });
        }
        return FV.refreshCartCount().then(function () {
          FV.openCart();
          return data;
        });
      })
      .catch(function (err) {
        if (window.console) console.warn('[FV] add to cart failed:', err && err.message);
        throw err;
      })
      .then(
        function (d) { restore(); return d; },
        function (e) { restore(); throw e; }
      );

    function restore() {
      if (!button) return;
      button.disabled = false;
      button.style.opacity = '1';
      if (originalText !== null) {
        setTimeout(function () { button.innerHTML = originalText; }, 1200);
      }
    }
  };

  /* ======================================================================
     3. Swiper — one version, loaded once, on demand
     ss-circle-menu loaded v11 while homeshop-video ran a v8 config against
     whatever had already landed, styled with v9 CSS. Now: one loader.
     ====================================================================== */
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var swiperQueue = [];
  var swiperState = 0;

  FV.loadSwiper = function (callback) {
    if (window.Swiper) { swiperState = 2; callback(); return; }
    swiperQueue.push(callback);
    if (swiperState === 1) return;
    swiperState = 1;

    FV.loadStyle(SWIPER_CSS);

    var script = document.createElement('script');
    script.src = SWIPER_JS;
    script.async = true;
    script.onload = function () {
      swiperState = 2;
      var q = swiperQueue;
      swiperQueue = [];
      q.forEach(function (cb) {
        try { cb(); } catch (e) { /* one broken slider must not kill the rest */ }
      });
    };
    script.onerror = function () { swiperState = 0; swiperQueue = []; };
    document.head.appendChild(script);
  };

  var scripts = {};
  FV.loadScript = function (src, callback) {
    if (scripts[src] === 2) { callback(); return; }
    scripts[src + '__q'] = scripts[src + '__q'] || [];
    scripts[src + '__q'].push(callback);
    if (scripts[src]) return;
    scripts[src] = 1;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = function () {
      scripts[src] = 2;
      (scripts[src + '__q'] || []).forEach(function (cb) { cb(); });
      scripts[src + '__q'] = [];
    };
    document.head.appendChild(s);
  };

  FV.loadStyle = function (href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  };

  window.FV = FV;
})();
